import { filterItems } from "lib/helper";
import { helper } from "lib/helper";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Table,
  Input,
} from "reactstrap";
// core components
import TablePagination from "views/components/TablePagination";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ExportButton from "components/ExportButton";
import usersModel from "models/users.model";
import adminModel from "models/admin.model";
import TableHeader from "components/TableHeader/TableHeader";

const BuddyList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredDataList, setFilteredDataList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const tableRef = useRef(null);
  const navigate = useNavigate();

  const getAllUsers = async () => {
    try {
      const res = await usersModel.getAllUsers();
      const buddies = res.users.filter((item) => item.type === 'buddy');
      setFilteredDataList(buddies);
      setDataList(res.users);
    } catch (error) {
      console.log(error);
    }
  };

  const isWithinDateRange = (dateStr) => {
    const createdDate = new Date(dateStr);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
    if (from && createdDate < from) return false;
    if (to && createdDate > to) return false;
    return true;
  };

  const filteredUsers = filterItems(filteredDataList, searchQuery, ['firstName', 'lastName', 'email', 'mobileNo']).filter((item) =>
    isWithinDateRange(item.createdAt)
  );

  const indexOfLastUser = currentPage * perPage;
  const indexOfFirstUser = indexOfLastUser - perPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDel = (id) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this User?", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          adminModel.userDelete(id).then((res) => {
            helper.sweetalert.toast(res?.data?.message);
            getAllUsers();
          });
        }
      });
  };

  const columnsConfig = [
    { label: "S.No", getValue: (item, index) => index + 1 },
    { label: "Name", getValue: (item) => item?.firstName + ' ' + item?.lastName },
    { label: "Email", getValue: (item) => item.email || "N/A" },
    { label: "Mobile", getValue: (item) => item.mobileNo },
    { label: "Date of Birth", getValue: (item) => new Date(item?.dob).toLocaleDateString('en-GB') },
   
  ];

  const options = ['#', 'First Name', 'Last Name', 'Email', 'Mobile', 'Date of Birth', 'Created On',  'Actions'];

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <Container className="pt-6" fluid style={{ maxWidth: "100%", fontFamily: 'Montserrat' }}>
      {!isLoading && (
        <Row>
          <div className="col pl-0 pr-0">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Buddies</h3>
                <div className="d-flex align-items-center flex-wrap gap-2">
                <div>
                  <lebal className="text-sm">Search</lebal>
                  <Input
                    type="text"
                    placeholder="Search Here..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ width: "200px", marginRight: "10px" }}
                    />
                    </div>
                    <div className="ml-2">
                    <lebal className="text-sm">Form date</lebal>
                    <Input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div>
                  <div className="ml-2">
                    <lebal className="text-sm">To date</lebal>
                    <Input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      style={{ marginRight: "10px" }}
                    />
                  </div>
                  
                  <div className=" ml-3 mt-4">
                  <ExportButton data={filteredDataList} columnsConfig={columnsConfig} />
                  </div>
                </div>
              </CardHeader>
              <div ref={tableRef}>
                <Table className="align-items-center table-flush" responsive>
                  <TableHeader options={options} />
                  <tbody>
                    {currentUsers.map((item, index) => (
                      <tr key={item._id}>
                        <td>{indexOfFirstUser + index + 1}</td>
                        <td>{item.firstName}</td>
                        <td>{item.lastName}</td>
                        <td>{item?.email || "N/A"}</td>
                        <td>{item?.mobileNo}</td>
                        <td>{new Date(item?.dob).toLocaleDateString('en-GB')}</td>
                        <td>{new Date(item?.createdAt).toLocaleDateString('en-GB')}</td>
                        
                        <td>
                          <Button color="primary" size="sm" className="mr-2" onClick={() => navigate('/admin/user/view/' + item._id)}><i className="fa-solid fa-eye"></i></Button>
                          <Button color="warning" size="sm" className="mr-2" onClick={() => navigate('/admin/user/edit/' + item._id)}><i className="fa-regular fa-pen-to-square"></i></Button>
                          <Button color="danger" size="sm" onClick={() => handleDel(item._id)}><i className="fa-solid fa-trash"></i></Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <CardFooter className="py-4">
                <TablePagination
                  totalPages={Math.ceil(filteredUsers.length / perPage)}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  pageUrl="/admin/users?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      )}
    </Container>
  );
};

export default BuddyList;
